import React from "react";

const PrivacyNoticeScreen = () => {
  return <></>;
};

export default PrivacyNoticeScreen;
